import { Component, Inject } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";

@Component({
  selector: "app-import-preview-dialog",
  templateUrl: "./import-preview-dialog.component.html",
  standalone: false,
})
export class ImportPreviewDialogComponent {
  constructor(
    public dialogRef: VngDialogRef<ImportPreviewDialogComponent>,
    @Inject(VNG_DIALOG_DATA) public data: { shortcut: any },
  ) {}

  done(): void {
    this.dialogRef.close();
  }
}
